// Vuetify 3 plugin. The Vuetify 2 a-la-carte `Vue.use(Vuetify, { components })`
// registration is gone; components are auto-imported by webpack-plugin-vuetify
// (configured in vue.config.js) or imported explicitly. Here we register all
// components/directives for simplicity during the migration spike.
import 'vuetify/styles';
import { createVuetify } from 'vuetify';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';
import { aliases, mdi } from 'vuetify/iconsets/mdi';

export default createVuetify({
    components,
    directives,
    // Vuetify 3 selection controls default to a neutral (black) checked colour and
    // a comfortable density. Vuetify 2 rendered them primary-coloured and tighter,
    // so restore that globally.
    defaults: {
        VSelectionControl: { density: 'compact' },
        VCheckbox: { color: 'primary', hideDetails: 'auto' },
        VRadioGroup: { color: 'primary', density: 'compact', hideDetails: 'auto' },
        VRadio: { color: 'primary' },
        VSwitch: { color: 'primary', hideDetails: 'auto' },
        VSlider: { color: 'primary' },
        VBtn: {
            density: 'comfortable', // Options: 'default', 'comfortable', 'compact'
            color: '#0000008A'
        },
        VIcon: {
            color: '#0000008A'
        }
    },
    icons: {
        defaultSet: 'mdi',
        aliases,
        sets: { mdi },
    },
    theme: {
        defaultTheme: 'light',
        themes: {
            light: {
                colors: {
                    primary: '#009cbb',
                    secondary: '#424242',
                    accent: '#82B1FF',
                    error: '#FF5252',
                    info: '#2196F3',
                    success: '#4CAF50',
                    grey: '#9e9e9e',
                    white: '#ffffff',
                    'on-warning': '#fb8c00',
                    'warning': '#F8EEDF',
                }
            },
        },
    },
});
